import React, { useState, useEffect } from "react";
import "./SkillBar.css";

const SkillBar = ({ name, value, color, skillsLevelHandler, indexArray }) => {
  // const [level, setLevel] = useState(value); // Single skill level state
  const [hoveredLevel, setHoveredLevel] = useState(value); // Hovered level state

  // Handle mouse hover
  const handleMouseEnter = (level) => {
    setHoveredLevel(level);
  };

  // Handle mouse leave
  const handleMouseLeave = () => {
    setHoveredLevel(value); // Reset to original level after hover
  };

  // Handle click to set level
  const handleClick = (level) => {
    // setLevel(level); // Update the skill level on click
    console.log(`Skill updated: ${name}, Level: ${level}`);
    skillsLevelHandler(level, indexArray); // Notify parent component of the new value
  };

  useEffect(() => {
    setHoveredLevel(value);
  }, [value]);

  return (
    <div className="skillbar-container">
      <div className="skill-bar">
        <div className="skill-level">
          <div className="progress-bar horizontal">
            {Array.from({ length: 11 }, (_, i) => (
              <div
                key={i}
                className={`progress-segment ${i === 10 ? "display-only" : ""}`}
                style={{
                  backgroundColor:
                    i < 10
                      ? i < hoveredLevel
                        ? color
                        : "#1f1f1f4d" // Default background color for unselected
                      : "transparent", // 11th segment background is transparent
                  border:
                    i === 10
                      ? `2px solid ${color}` // Border matches unselected segments' color
                      : "none",
                  transition:
                    "background-color 0.2s ease, border-color 0.2s ease",
                  cursor: i < 10 ? "pointer" : "default",
                  position: "relative", // Ensures child elements like text can be aligned
                }}
                onMouseEnter={() => i < 10 && handleMouseEnter(i + 1)}
                onMouseLeave={() => i < 10 && handleMouseLeave()}
                onClick={() => i < 10 && handleClick(i + 1)}
              >
                {i === 10 && (
                  <span
                    className="skill-score"
                    style={{
                      color: color,
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)", // Center text both horizontally and vertically
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    {value}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkillBar;
